/* Hero comparison-pair rotator — the video fallback.
   Crossfades .hero__slide elements inside [data-hero-rotator]; dots navigate.
   Under prefers-reduced-motion there is no auto-advance (dots still work). */
(function () {
  'use strict';

  function initRotator(rotator) {
    var slides = rotator.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;

    var dots = rotator.querySelectorAll('.hero__dot');
    var interval = parseInt(rotator.getAttribute('data-interval'), 10) || 6000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function show(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (reduced) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });

    rotator.addEventListener('mouseenter', stop);
    rotator.addEventListener('mouseleave', start);
    rotator.addEventListener('focusin', stop);
    rotator.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  function init() {
    document.querySelectorAll('[data-hero-rotator]').forEach(initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
